import {
  AdminUserPermissionSet,
  EamAssetPermissionSet,
  EamEnergyEntryPermissionSet,
  EamInspectionPermissionSet,
  EamInventoryPermissionSet,
  EamIssuePermissionSet,
  EamMeterEntryPermissionSet,
  EamPartPermissionSet,
  EamServiceReminderPermissionSet,
  EamServiceTaskPermissionSet,
  EamWorkOrderPermissionSet,
  OperationalAlertsPermissionSet,
  OrganizationPermissionSet,
  PermissionSetType,
  SidebarProductVisibilityPermissionSet,
} from '../sets'
import { AdminMinimalRole } from './AdminMinimalRole'

/**
 * EAM Maintain User Role for personnel who use the Spare Maintain app on a daily basis.
 * This role includes permissions for viewing and managing EAM-related data.
 */
export const EamMaintainUserRole: PermissionSetType[] = [
  ...AdminMinimalRole,
  SidebarProductVisibilityPermissionSet.ShowEamProduct,
  OperationalAlertsPermissionSet.Subscribe,

  EamPartPermissionSet.View,
  EamInventoryPermissionSet.View,
  EamAssetPermissionSet.View,
  EamAssetPermissionSet.Write,
  EamAssetPermissionSet.ManageGroups,
  EamWorkOrderPermissionSet.View,
  EamWorkOrderPermissionSet.Write,
  EamMeterEntryPermissionSet.View,
  EamMeterEntryPermissionSet.Write,
  EamIssuePermissionSet.View,
  EamIssuePermissionSet.Write,
  EamServiceReminderPermissionSet.View,
  EamServiceTaskPermissionSet.View,
  EamEnergyEntryPermissionSet.View,
  EamEnergyEntryPermissionSet.Write,
  EamInspectionPermissionSet.View,
  EamInspectionPermissionSet.Write,

  AdminUserPermissionSet.View,
  OrganizationPermissionSet.ViewConfiguration,
]
